const SEARCH_TYPES = {
  MANUAL: 'manual',
  AI: 'ai',
} as const

type SearchType = (typeof SEARCH_TYPES)[keyof typeof SEARCH_TYPES]

const ERROR_CODES = {
  SERVER_ERROR: 'SERVER_ERROR',
  INVALID_PDF_EXCEPTION: 'InvalidPDFException',
  ERR_NOT_FOUND: 'ERR_NOT_FOUND',
} as const

export { 
  type SearchType, 
  SEARCH_TYPES,
  ERROR_CODES,
}
